export const TRANSIENT = "TRANSIENT"; // e.g. Auto closing page for Print/Export support
export const HORIZON_BASIC = "HORIZON_BASIC";
